'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    HamburgerMenu: {
        displayName: 'HamburgerMenu'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/Passenger/HamburgerMenu.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var HamburgerMenu = _wrapComponent('HamburgerMenu')((_dec = (0, _reduxUi2.default)(), _dec(_class = function (_Component) {
    (0, _inherits3.default)(HamburgerMenu, _Component);

    function HamburgerMenu(props) {
        (0, _classCallCheck3.default)(this, HamburgerMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HamburgerMenu.__proto__ || (0, _getPrototypeOf2.default)(HamburgerMenu)).call(this, props));

        _this.state = {
            clicked: false
        };
        return _this;
    }

    (0, _createClass3.default)(HamburgerMenu, [{
        key: 'handleClick',
        value: function handleClick() {
            this.props.updateUI("checkinDocumentsIsVisible", !this.props.ui.checkinDocumentsIsVisible);
            this.setState({
                clicked: !this.state.clicked
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react3.default.createElement(
                'div',
                { className: 'hamburger-menu ' + (this.state.clicked ? 'clicked' : '') },
                _react3.default.createElement(
                    'button',
                    {
                        onClick: this.handleClick.bind(this)
                    },
                    _react3.default.createElement(_components2.IconDown, null)
                )
            );
        }
    }]);
    return HamburgerMenu;
}(_react2.Component)) || _class));

exports.default = HamburgerMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Passenger/HamburgerMenu.js
// module id = 1303
// module chunks = 0